import { makeImage } from '../utils/makeImage'

export interface DocHeaderType {
  urlImage: string
  titulo: string
  isAnulada: boolean
  tituloAnulada: string
  fechaIniText: string
  fechaIniValue: string
  fechaFinText: string
  fechaFinValue: string
}

import { useFeatureFlag } from '../hooks/useFeatureFlag'

import { DocHeader as DocHeaderV2 } from './DocHeaderV2'

export const DocHeader: React.FC<{ header: DocHeaderType }> = ({ header }) => {
  const { useNewDocumentUI } = useFeatureFlag()

  if (useNewDocumentUI) return <DocHeaderV2 header={header} />

  return (
    <div className="flex items-center justify-between p-0 w-full">
      {/* Image Section */}
      <div className="flex-shrink-0">
        <img src={makeImage(header.urlImage)} alt="Logo" className="h-12" />
      </div>

      {/* Single Text Section */}
      <div className="text-center md:text-left">
        <p className="text-[1.5em] font-semibold">{header.titulo}</p>
        {header.isAnulada && <p className="text-[1.125em] font-bold text-indigo-600">{header.tituloAnulada}</p>}
      </div>

      {/* Stacked Text Section */}

      <div className="text-center md:text-left">
        <div className="flex justify-between">
          <div className="text-sm font-medium text-left mr-2">{header.fechaIniText}</div>
          <div className="text-sm font-medium text-right">{header.fechaIniValue}</div>
        </div>
        <div className="flex justify-between">
          <div className="text-sm font-medium text-left mr-2">{header.fechaFinText}</div>
          <div className="text-sm font-medium text-right">{header.fechaFinValue}</div>
        </div>
      </div>
    </div>
  )
}
